import React from 'react';
import { CalendarDays, UserRound, Clock3 } from 'lucide-react';

/** Compact reminder of specialty / doctor / when before patient details. */
export default function BookingPickSummary({ specialty, doctorName, date, slot, primary }) {
  const items = [
    { Icon: UserRound, label: specialty || 'OPD', sub: doctorName },
    { Icon: CalendarDays, label: date, sub: null },
    { Icon: Clock3, label: slot === 'day' ? 'Same-day place' : slot, sub: null },
  ].filter((x) => x.label);
  return (
    <div
      className="mb-4 rounded-xl border border-white/12 bg-white/[0.04] px-3 py-2.5 flex flex-wrap gap-3"
      data-testid="booking-pick-summary"
      style={{ borderColor: `${primary}44` }}
    >
      {items.map(({ Icon, label, sub }) => (
        <div key={`${label}-${sub || ''}`} className="flex items-center gap-2 min-w-0">
          <Icon className="h-3.5 w-3.5 flex-shrink-0" style={{ color: primary }} />
          <div className="min-w-0">
            <p className="text-[12px] font-medium text-zinc-100 truncate">{label}</p>
            {sub ? <p className="text-[10px] text-zinc-500 truncate">{sub}</p> : null}
          </div>
        </div>
      ))}
    </div>
  );
}
